<template lang="pug">
div
  template(v-if="!isLoggedIn")
    //- register
    //- login
    //- forgotPassword
  template(v-else)
    review
    reviewComplete
  popupBanner
  tutorial
  partnerList
  .topnav
    .topnavbar
      .con
        .nlbar
          .sidebar-menu.nb-sidebar-switch(@click="toggleSidebar" ref="sidebarToggle")
            img(src="/new/img/menu/menu.gif")
          .logo
            router-link(to="/")
              img(src='/new/img/logo.png')
        .nvbar
          .nbin(v-if="!isLoggedIn")
            a.btns(href='javascript:void(0)' @click="$router.push('/login').catch(err => {})") {{$t('ui.login')}}
            a.btns.s2.d-flex.flex-column.align-items-center(href='javascript:void(0)' @click="$router.push('/register').catch(err => {})")
              span.animate__animated.animate__flash.animate__infinite {{$t('ui.register')}}
            //- img.pointer(src="/new/img/raya-angpow.png" @click="$router.push('/login')" style="max-width: 40px")
            //- a.btns.s2.d-flex.flex-column.align-items-center(href='javascript:void(0)' style="gap:0; line-height:1;padding-bottom: 0" @click="$router.push('/register').catch(err => {})")
              span.animate__animated.animate__flash.animate__infinite {{$t('ui.register')}}
              span.text-danger(style="font-size: 10px") FREE MYR50
          .nbin(v-if="isLoggedIn")
            .af-user
              //- .u-info.pointer.me-2.ticket-display(@click="$router.push('/deposit')")
                span.u-name {{ $t('ui.giveaway_ticket') }}: 
                span.u-amo {{ giveawayTicket }}
              img.pointer(@click="$router.push('/profile')" src='/new/img/af/user.png')
              .u-info.pointer(@click="$router.push('/deposit')")
                span.u-name {{accountID}} 
                span.u-amo MYR {{ $numeral($store.getters.balance).format("0,0.00") }}
              //- img.pointer(src="/new/img/raya-angpow.png" @click="toEx('https://forms.gle/SNx1PxhsdCXnJF6t6')")
              img.pointer(v-if="getVip!==''" :src="'/new/img/vip/'+getVip+'.png'" @click="$router.push('/vip')" src='/new/img/vip/bronze.png')
          language
    //- .u-info.pointer.me-2.ticket-mobile
      span.u-amo.me-2 {{ $t('ui.giveaway_ticket') }}: 
      span.u-amo.me-2 {{ giveawayTicket }}
      i.fa-solid.fa-circle-chevron-right
  .main-wrap
    sidebar(v-click-outside="closeSidebar")
    router-view
    depoProgress(v-if="currentPath === '/'")
  .btmnav
    router-link.btns2(to="/" :class="{'aaa': currentPath==='/'}")
      img(src='/new/img/menu/m/home.png')
      span {{$t('ui.menu.home')}}
    router-link.btns2(to="/promotions" :class="{'aaa': currentPath==='/promotions'}")
      img(src='/new/img/menu/m/promo.png')
      span {{$t('ui.menu.promo')}}
    router-link.btns2.hl(v-if="isLoggedIn" to="/deposit")
      img(src='/new/img/menu/m/deposit.png')
      span {{$t('ui.menu.deposit')}}
    a.btns2.hl(v-if="!isLoggedIn" href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
      img(src='/new/img/menu/m/deposit.png')
      span {{$t('ui.menu.deposit')}}
    a.btns2(href="javascript:void(0)" @click="openChat")
      //- .notify.blink 1
      img(src='/new/img/menu/m/livechat.png')
      span {{$t('ui.menu.livechat')}}
    template(v-if="isLoggedIn")
      router-link.btns2(to="/inbox" :class="{'aaa': currentPath==='/inbox'}")
        img(src='/new/img/menu/m/inbox.png')
        span {{$t('ui.inbox')}}
    template(v-else)
      a.btns2(href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
        img(src='/new/img/menu/m/inbox.png')
        span {{$t('ui.inbox')}}
  floatingWidget
  //- #floatingContainer.floating-container(
  //-   v-if="currentPath==='/'"
  //-   ref="floatContainer"
  //-   @mousedown="startDrag"
  //-   @touchstart="startDrag"
  //-   @click.capture="blockClickAfterDrag"
  //- )
  //-   button#toggleBtn.toggle-btn(@click="toggleFloat")
  //-     .toggle-arrow
  //-       img(v-if="expandFloat == false" src="/new/img/float/up.svg")
  //-       img(v-if="expandFloat == true" src="/new/img/float/down.svg")
  //-       //- svg#svg-chevron.svg-chevron(height='15px' width='15px' viewbox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='none')
  //-         g#SVGRepo_bgCarrier(stroke-width='0')
  //-         g#SVGRepo_tracerCarrier(stroke-linecap='round' stroke-linejoin='round')
  //-         g#SVGRepo_iconCarrier
  //-           path(fill='#ffff' fill-rule='evenodd' d='M2.293 15.293a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414l-6-6a1 1 0 00-1.414 1.414L7.586 10l-5.293 5.293zm8 0a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414l-6-6a1 1 0 10-1.414 1.414L15.586 10l-5.293 5.293z')
  //-   #content.content
  //-     template
  //-       .avatar.always-visible
  //-         //- a(href="https://www.tiktok.com/@epinwin_" target="_blank")
  //-         router-link(to="/rezeki")
  //-           img(width='100%' src='/new/img/rezeki.png' alt='')
  //-       .avatar(:class="{'visible': expandFloat == true}")
  //-         a(href="https://igamingtips.org/winning-tips/" target="_blank")
  //-           img(width='100%' src='/new/img/winningtips.png' alt='')
  //-       //- .avatar(:class="{'visible': expandFloat == true}")
  //-         router-link(to="/daily-check-in")
  //-           img(width='100%' src='/new/img/float/daily.gif' alt='')
  //-       //- .avatar(:class="{'visible': expandFloat == true}")
  //-         router-link(to="partners")
  //-           img(width='100%' src='/new/img/float/partner.gif' alt='')
  //-       //- .avatar(:class="{'visible': expandFloat == true}")
  //-         a(href="https://epicwincuci.com/RF11563559" target="_blank")
  //-           img(width='100%' src='/new/img/link.png' alt='')
  //-       //- .avatar(v-if="$helpers.timingFilter('2026-04-01 12:00')" :class="{'visible': expandFloat == true}") 
  //-         a(href="https://www.epwin7.com/RF23AA9A10" target="_blank")
  //-           img(width='100%' src='/new/img/epicvip.png' alt='')
  //-       .avatar(:class="{'visible': expandFloat == true}")
  //-         a(href="https://wa.link/fbkjpq" target="_blank")
  //-           img(width='100%' src='/new/img/float/whatsapp-icon.png' alt='')
  //-       .avatar(:class="{'visible': expandFloat == true}")
  //-         a(href="https://t.me/epicgroupfree100" target="_blank")
  //-           img(width='100%' src='/new/img/float/group-telegram.png' alt='')
  //-       .avatar(:class="{'visible': expandFloat == true}")
  //-         a(v-if="showPrompt && !isIOS" href="javascript:void(0)" @click="triggerDownload")
  //-           img(width='100%' src='/new/img/float/app.png' alt='')
  //-         a(v-if="isIOS && showTutorial" href='javascript:void(0)' @click="openTutorial()")
  //-           img(width='100%' src='/new/img/float/app.png' alt='')
  //- router-link.june-floating(to="/highlights")
    img(src="/new/img/float/july-floating.gif")
  //- .float-left.pointer(v-if="currentPath==='/' && showFloat")
    img(src='/new/img/float/8k.gif' @click="toEx('https://www.epwin7.com/RF23AA9A10')")
    .float-close(@click="hideFloat")
      i.fa-solid.fa-circle-xmark
  //- .float-icon-wrap.nb-float-icon(v-if="currentPath==='/'" :class="{'close': hideIcon}" )
    .float-act.nb-float-act.border-0.pointer(@click="toggleIcon")
      .triangle.triangle-2
        i.fa-solid.fa-angle-right
    .float-icon
      a(v-if="!isIOS" href="https://dapk.epwin21.com/epicwin.apk" target="_blank")
        img(src='/new/img/side/app.png')
      a(v-if="isIOS" href='javascript:void(0)' @click="openTutorial")
        img(src='/new/img/side/app.png')
      a(v-if="$helpers.timingFilter('2025-08-01 08:00')" href='https://gcash23.ph/RF15782682' target="_blank")
        img(src='/new/img/side/gcash.gif')
      a(v-else href='https://maya23.ph/RF1A328023' target="_blank")
        img(src='/new/img/side/maya.gif')
      router-link(to="partners")
        img(src='/new/img/menu/partner.gif')
</template>
<script>
import config from "@/config";
import _ from "lodash";
import sidebar from "@/views/default/_sidebar.vue";
import topbar from "@/views/default/_topBar.vue";
import language from "@/component/_language.vue"
import tabList from "@/views/default/_tabs.vue";
import register from "@/component/_register.vue";
import login from "@/component/_login.vue";
import forgotPassword from "@/component/_forgotPassword.vue";
import popupBanner from "@/component/_popupBanner.vue";
import footerBanner from "@/views/default/_footerBanner.vue";
import footerInfo from "@/views/default/_footer.vue";
import footerArticle from "@/views/default/_footerArticle.vue";
import tutorial from "@/component/_tutorial.vue";
import review from "@/component/review/_review.vue";
import reviewComplete from "@/component/review/_reviewComplete.vue";
import depoProgress from "@/component/_depoProgress.vue"
import { EventBus } from '@/store/event';
import partnerList from "@/component/_partnerList.vue";
import floatingWidget from "@/component/floatingWidget.vue";
export default {
  metaInfo(){
    var site = window.location.protocol + "//" + window.location.hostname + "/";    
  },
  components: {
    sidebar,
    tabList,
    topbar,
    language,
    register,
    login,
    forgotPassword,
    popupBanner,
    footerBanner,
    footerInfo,
    footerArticle,
    tutorial,
    review,
    reviewComplete,
    depoProgress,
    partnerList,
    floatingWidget
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        // Handler for click outside event
        el.__ClickOutsideHandler__ = function (event) {
          // Ensure that the click target is not the sidebar itself
          if (window.innerWidth < 768 && !el.contains(event.target) && !vnode.context.$refs.sidebarToggle.contains(event.target)) {
            // Execute the passed method (closeSidebar)
            binding.value();
          }
        };
        // Add click event listener to body
        document.body.addEventListener('click', el.__ClickOutsideHandler__);
      },
      unbind(el) {
        // Clean up event listener when directive is destroyed
        document.body.removeEventListener('click', el.__ClickOutsideHandler__);
        el.__ClickOutsideHandler__ = null;
      }
    }
  },
  data() {
    return {
      showMobile: false,
      showTop: false,
      showBalance: false,
      showProfile:false,
      currentPath: "",
      hideIcon: false,
      refreshVip:null,
      refreshBalance: null,
      hideAnn: false,
      feedback: {
        success: true,
        status: ""
      },
      showSb: false,
      showPrompt: false,
      isIOS: false,
      showTutorial: false,
      showDownload: false,
      showLang: false,
      showTopbanner: true,
      fbp: null,
      pixelId: "",
      siteName:"",
      expandFloat:false,
      showFloat:true,
      isDragging: false,
      hasDragged: false,
      offsetX: 0,
      offsetY: 0,
      startX: 0,
      startY: 0
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    getAvatar() {
      return this.$store.getters.getAvatar;
    },
    getCurrentLevel() {
      return this.$store.getters.getCurrentLevel;
    },
    getFbLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "facebook"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getTgLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "telegram"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getIgLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "instagram"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getYtLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "youtube"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getVip(){
      return this.$store.state.user.vip
    },
    getInboxList(){
      return this.$store.state.user.inbox.length
    },
    giveawayTicket(){
      return this.$store.state.user.giveawayTicket
    }
    // downloadLink(){
    //   return window.location.protocol + "//" + window.location.hostname + "/new/download/epicwin.apk";
    // },
  },
  watch: {
    isLoggedIn(newState, oldState){
      if(newState){
        this.firstBalance()
        this.getMemberEwallet()
        this.getMemberBankList()
        this.getFavlist()
        this.giveAwayticketbalance()
        // this.loginLog()
      }
    },
    $route(to, from) {
      this.currentPath = to.path;
      if (
        to.path === "/referral" ||
        to.path === "/deposit" ||
        to.path === "/profile" ||
        to.path === "/setting" ||
        to.path === "/withdrawal" ||
        to.path === "/statement" ||
        to.path === "/inbox" ||
        to.path === "/contactUs" ||
        to.path === "/promotions" || 
        to.path === "/livestream" ||
	      to.path === "/vip" ||
        to.path === "/ambassador"
      ) {
        this.showTop = true;
        this.showBalance = true;
      } else {
        this.showTop = false;
        this.showBalance = false;
      }
    },
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        // window._smartico_user_id = null;
        // window._smartico_language = null;
        // vm.$store.dispatch("user/setCurrentLevel", "");
      }
    }
  },
  created() {
    if (Object.keys(this.$route.query).length > 0) {
      this.checkAnn(0)
    }else{
      this.checkAnn(1);
    }
    this.getSocialList();
  },
  beforeMount() {
    this.getMobile();
    this.checkSize();
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      this.triggerEvent = e;
      this.showPrompt = true;
    });
  },
  updated(){
    if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.checkProfile == true){
				this.showProfile = true
			}
    }
  },
  mounted() {
    var vm = this;
    this.currentPath = this.$router.currentRoute.path;
    if (
      this.$router.currentRoute.path === "/referral" ||
      this.$router.currentRoute.path === "/deposit" ||
      this.$router.currentRoute.path === "/profile" ||
      this.$router.currentRoute.path === "/setting" ||
      this.$router.currentRoute.path === "/withdrawal" ||
      this.$router.currentRoute.path === "/statement" ||
      this.$router.currentRoute.path === "/inbox" ||
      this.$router.currentRoute.path === "/contactUs" ||
      this.$router.currentRoute.path === "/promotions" || 
      this.$router.currentRoute.path === "/livestream" ||
      this.$router.currentRoute.path === "/vip" ||
      this.$router.currentRoute.path === "/ambassador"
    ) {
      this.showTop = true;
      this.showBalance = true;
    } else {
      this.showTop = false;
      this.showBalance = false;
    }
    
    $(".chat-close").click(function() {
      $(".chat-gif")
        .removeClass("d-block")
        .addClass("d-none");
      $(".chat-close")
        .removeClass("d-block")
        .addClass("d-none");
    });
    if (!_.isEmpty(this.$route.query)) {
      if(this.$route.query.promo){
        this.hideAnn = true
      }

      if (this.isLoggedIn) {
        this.$router.replace(this.currentPath);
      }
      if (this.$route.query.promo) {
        var target = parseInt(this.$route.query.promo)
        this.$router.push("/promotions").catch(error =>{}).finally(() => {
          this.$nextTick(() => {
            EventBus.$emit('custom', target);
          });
        });
        
      }else{
        // this.$router.replace("/");
      }
      // this.$router.replace("/");
    }
    if (this.$store.getters.isLoggedIn) {
      this.getBalance()
      this.getMemberVip()
      this.getInbox()
      this.giveAwayticketbalance()
    }
    this.refreshBalance = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.getBalance()
        this.getInbox()
        this.giveAwayticketbalance()
      }
    }, 8000)
    this.refreshVip = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.getMemberVip()
        // this.getInboxList()
      }
    }, 15000)

    //floating container dragging
    window.addEventListener('mousemove', this.onDrag)
    window.addEventListener('mouseup', this.stopDrag)

    window.addEventListener('touchmove', this.onDrag, { passive: false })
    window.addEventListener('touchend', this.stopDrag)
    
  },
  beforeDestroy: function() {
    clearInterval(this.refreshBalance)
    clearInterval(this.refreshVip)
    // clearInterval(this.refreshInbox)
    // clearInterval(this.continueRefreshInbox)
    window.removeEventListener('mousemove', this.onDrag)
    window.removeEventListener('mouseup', this.stopDrag)

    window.removeEventListener('touchmove', this.onDrag)
    window.removeEventListener('touchend', this.stopDrag)
  },
  methods: {
    hideFloat(){
      this.showFloat = false
    },
    toEx(link){
			window.open(link, "_blank")
		},
    closeSidebar() {
      $('body').removeClass('hnb');
    },
    toggleSidebar(){
      // this.showSb = !this.showSb
      // if(this.showSb){
        
      // }else{

      // }
      $('body').toggleClass('hnb')
      setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
      }, 400);
      return false
    },
    toProfile(){
      this.showProfile = false
      this.$router.push("/profile").catch(error =>{})
    },
    appflyerSubmit() {
      var vm = this;
      this.siteName = window.location.protocol + "//" +window.location.hostname
      var url = config.appflyerSubmit();
      this.$http
        .post(url, {
          "fbp": this.fbp,
          "pixelId": this.pixelId,
          "domain": this.siteName,
        })
        .then(
          successResponse => {
            if (successResponse) {
              if (typeof successResponse.data.status == "string") {
                this.feedback.success = successResponse.status == "1";
              } else {
                this.feedback.success = successResponse.status == 1;
              }
              this.feedback.status = successResponse.status;
              if (this.feedback.success == true) {
              } else {
              }
            } else {
            }
          },
          errorResponse => {
            console.log(errorResponse);
          }
        );
    },
    toggleLang() {
      this.showLang = !this.showLang;
    },
    getMobile() {
      let isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        }
      };

      if (isMobile.iOS()) {
        this.isIOS = true
        this.showTutorial = true
      } else {
        this.isIOS = false
        this.showTutorial = false
      }
    },
    hideTopbanner(){
      this.showTopbanner = false
    },
    hideDownload(){
      this.showDownload = false
    },
    hideTutorial() {
      this.showTutorial = false;
    },
    openTutorial() {
      $("#modal-tutorial").modal("show");
    },
    rules() {
      // _smartico.dp("dp:gf_section&id=91")  //rules
      _smartico.dp("dp:gf_saw"); //wheel
    },
    eventAction() {
      if (this.isLoggedIn) {
        $("#leaderboard-modal").modal("show");
        // window._smartico.showWidget('ui-widget', { iframe: 'testIframe', zoom: 1, height: 'auto', wuuid: '100005/79d12290-d465-11ee-9aa0-0228c1221b89', id: 2} )
      } else {
        this.openLogModal();
      }
    },
    toggleIcon() {
      this.hideIcon = !this.hideIcon;
    },
    openModal(target) {
      $(target).modal("show");
    },
    getDisplayWord() {
      switch (this.$router.currentRoute.path) {
        case "/referral":
          return this.$t("ui.referral");
        case "/profile":
          return this.$t("ui.profile");
        case "/deposit":
          return this.$t("ui.deposit");
        case "/withdrawal":
          return this.$t("ui.withdrawal");
        case "/statement":
          return this.$t("ui.statement");
        case "/inbox":
          return this.$t("ui.inbox");
        case "/contactUs":
          return this.$t("ui.follow_us");
        case "/promotions":
          return this.$t("ui.promotion");
        case "/livestream":
          return "Live Stream"
        case "/ambassador":
          return "Ambassador"
        case "/profile":
          return this.$t('ui.profile');
	      case "/vip":
          return "VIP";
      }
    },
    
    checkSize() {
      if ($(window).width() < 681) {
        this.showMobile = true;
      } else {
        this.showMobile = false;
      }
    },
    openChat() {
      LiveChatWidget.call("maximize");
    },
    triggerDownload() {
      this.triggerEvent.prompt();
      //user response
      this.triggerEvent.userChoice.then(response => {
        if (response.outcome === "accepted") {
          this.showPrompt = false;
        } else {
        }
      });
    },
    getSocialList() {
      this.$store
        .dispatch("user/getSocialList", {})
        .then(response => {
          if (response.success == true) {
            // this.socialList = response.data.value
          } else {
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
            }
          }
        })
        .catch(response => {
          if (typeof response.status != "object") {
            this.$helpers.showDialog(
              this.$t("ui.attention"),
              this.$t("message.list." + response.status),
              "info",
              this
            );
          }
        });
    },
    firstBalance(){
      var vm = this
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getBalance() {
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              clearInterval(this.refreshBalance)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                vm.logout()
              });
            }  
            if(response?.status?.status == 0){
              console.log('Network Error')
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getMemberVip(){
      if (this.sessionToken) {
        var vm = this
        this.loading = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberVip", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.loading = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              clearInterval(this.refreshVip)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                vm.logout()
              });
            }
            if(response?.status?.status == 0){
              console.log('Network Error')
            }
            this.loading = false
          })
      }
    },
    getInbox(){
      if(this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.loading = true
        this.$store
          .dispatch("user/getInbox", { account_id, auth_token })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
            } else {
              this.feedback.status = this.$t("error." + response.status)
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            var vm = this
            if((typeof response.status) != 'object'){
              clearInterval(this.refreshBalance)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                vm.logout()
              });
              if(response?.status?.status == 0){
                console.log('Network Error')
              }
            }
          });
      }
    },
    getMemberEwallet(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberEwallet", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getMemberBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberBankList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
							
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getFavlist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
							// console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    checkAnn(option){
      this.$store
        .dispatch("user/getAnnBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            if(response.annBeforeLog === true){
              if (this.hideAnn == true) {
                  
              }else{
                if(!this.isLoggedIn){
                  if (option != 0) {
                    if(this.currentPath == "/"){
                      $("#annModal").modal("show");
                    }
                  }
                }
              }
              
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
      // if(!this.$store.getters.isLoggedIn){
      //   if(this.$store.state.user.annBeforeLog === true){
      //     $("#modal-banner").modal("show");
      //   }
      // }
    },
    logout() {
      this.$store
        .dispatch("user/logout")
        .catch(err => {})
    },
    toggleFloat(){
      this.expandFloat = !this.expandFloat
    },
    giveAwayticketbalance(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/giveAwayticketbalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    startDrag(e) {
      const box = this.$refs.floatContainer
      const rect = box.getBoundingClientRect()

      const clientX = e.type.includes('touch')
        ? e.touches[0].clientX
        : e.clientX

      const clientY = e.type.includes('touch')
        ? e.touches[0].clientY
        : e.clientY

      this.isDragging = true
      this.hasDragged = false

      this.startX = clientX
      this.startY = clientY

      this.offsetX = clientX - rect.left
      this.offsetY = clientY - rect.top
    },

    onDrag(e) {
      if (!this.isDragging) return

      const clientX = e.type.includes('touch')
        ? e.touches[0].clientX
        : e.clientX

      const clientY = e.type.includes('touch')
        ? e.touches[0].clientY
        : e.clientY

      const moveX = Math.abs(clientX - this.startX)
      const moveY = Math.abs(clientY - this.startY)

      // only count as drag after moving more than 5px
      if (moveX > 5 || moveY > 5) {
        this.hasDragged = true

        // important for mobile drag
        e.preventDefault()

        const box = this.$refs.floatContainer

        // remove bottom/right positioning once dragged
        box.style.bottom = 'auto'
        box.style.right = 'auto'

        box.style.left = `${clientX - this.offsetX}px`
        box.style.top = `${clientY - this.offsetY}px`
      }
    },

    stopDrag() {
      this.isDragging = false
    },
    blockClickAfterDrag(e) {
      // this blocks child click only after drag
      if (this.hasDragged) {
        e.preventDefault()
        e.stopPropagation()

        this.$nextTick(() => {
          this.hasDragged = false
        })
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.before-log {
  grid-template-columns: 50% 50%;
}
.article-view {
  @media (min-width: 681px) {
    padding-bottom: 0 !important;
  }
}
.ticket-display{
  display: none;
  @media (min-width: 678px) {
    display: flex;
  }
}
.june-floating{
  position: fixed;
  right: 0;
  top: 15%;
  width: 40px; 
  z-index: 2;
}
</style>
